import type { FC } from "react";
import { EventList, type EventListVariant } from "@/ui/molecules/EventList";
import type { LedgerEntry } from "@/utils/models";
import { RequestOriginLedgerEntryRow } from "./RequestOriginLedgerEntryRow";
import type { OriginCopyContext } from "./requestOriginCopy";

type Props = {
	entries: readonly LedgerEntry[];
	/** `timeline` for the request's own story; `divided` for a merged-in request's story inside one of its steps. */
	variant: EventListVariant;
	copy: OriginCopyContext;
	dataTestId: string;
	/** Each row's test id is `${entryTestIdPrefix}-${index}`. */
	entryTestIdPrefix: string;
};

/**
 * A request's entries as the steps of one story: earliest first, each with the slots it opened (+N, brand) or closed
 * (−N, neutral) on the right, the step the request stands at now picked out. A merged-in step carries the merged
 * request's own story inside it.
 */
export const RequestOriginLedgerList: FC<Props> = ({ entries, variant, copy, dataTestId, entryTestIdPrefix }) => (
	<EventList variant={variant} dataTestId={dataTestId}>
		{entries.map((entry, index) => (
			<RequestOriginLedgerEntryRow
				// biome-ignore lint/suspicious/noArrayIndexKey: entries carry no id and are an append-only history; nothing reorders them.
				key={index}
				entry={entry}
				isLatest={variant === "timeline" && index === entries.length - 1}
				copy={copy}
				testId={`${entryTestIdPrefix}-${index}`}
			/>
		))}
	</EventList>
);
